import { render, staticRenderFns } from "./RiskAreaEvalutionDialog.vue?vue&type=template&id=17a24e47"
import script from "./RiskAreaEvalutionDialog.vue?vue&type=script&lang=js"
export * from "./RiskAreaEvalutionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports